import { API } from "aws-amplify";
import { publicSearch as publicSearchQuery } from "./graphql/queries";

const publicSearch = (requests, searchSource) =>
  API.graphql({
    query: publicSearchQuery,
    variables: { requests: JSON.stringify(requests), searchSource },
    authMode: "API_KEY",
  });

export default publicSearch;
